/**
 * Phase 87bk — Indicateur de fraîcheur des données Nayax (page Ventes)
 *
 * Affiche en temps réel :
 *  - Le temps écoulé depuis le dernier rafraîchissement de la page (auto-refresh 60s)
 *  - Le temps restant avant la prochaine sync Nayax (scheduler 15 min)
 *
 * Sert à rassurer l'opérateur : pas besoin d'aller dans Moma, les données ici sont
 * à jour à la minute près. Critical pour les distribs 24/7 (ex: Novelis 3x8) où le
 * pic de demande peut survenir à n'importe quelle heure.
 */
import React, { useEffect, useState } from "react";
import { Badge } from "../ui/badge";
import { Clock, RefreshCw } from "lucide-react";

function relMinutes(date) {
  if (!date) return null;
  return Math.floor((new Date() - new Date(date)) / 60000);
}

function relMinutesUntil(date) {
  if (!date) return null;
  return Math.ceil((new Date(date) - new Date()) / 60000);
}

export function NayaxFreshness({ status, lastRefreshAt }) {
  // Re-render toutes les 30 s pour rafraîchir les "il y a X min"
  const [, setTick] = useState(0);
  useEffect(() => {
    const i = setInterval(() => setTick((t) => t + 1), 30_000);
    return () => clearInterval(i);
  }, []);

  const refreshedAgo = relMinutes(lastRefreshAt);
  const nextSyncIn = relMinutesUntil(status?.scheduler?.next_run_at);
  const schedulerOK = status?.scheduler?.running === true;

  return (
    <>
      {refreshedAgo !== null && (
        <Badge
          variant="outline"
          className="text-[#1F4E3D] border-[#A8C9B6] bg-[#E8F2EC]"
          title="Délai depuis le dernier rafraîchissement de la page (auto toutes les 60s)"
          data-testid="ventes-refreshed-ago"
        >
          <RefreshCw className="w-3 h-3 mr-1" />
          {refreshedAgo === 0 ? "à l'instant" : `il y a ${refreshedAgo} min`}
        </Badge>
      )}
      {schedulerOK && nextSyncIn !== null && nextSyncIn >= 0 && (
        <Badge
          variant="outline"
          className="text-[#575A57]"
          title="Prochain passage du scheduler Nayax (15 min)"
          data-testid="ventes-next-sync"
        >
          <Clock className="w-3 h-3 mr-1" />
          Sync dans {nextSyncIn} min
        </Badge>
      )}
      {!schedulerOK && status !== null && (
        <Badge
          variant="outline"
          className="text-[#C05C47] border-[#E8B0A0] bg-[#FBEEEA]"
          title="Le scheduler Nayax est arrêté — contacte le support"
          data-testid="ventes-scheduler-down"
        >
          ⚠ Scheduler arrêté
        </Badge>
      )}
    </>
  );
}
